import { useEffect } from "react";

// Arrow keys step through moves and space toggles play; ignored while typing in a form field.
export default function useMoveKeys(handlers: { previous: () => void, next: () => void, togglePlay?: () => void }) {
    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            const target = event.target as HTMLElement | null;
            if (target && ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName) && target.getAttribute("type") !== "range") return;
            if (event.key === "ArrowLeft") handlers.previous();
            else if (event.key === "ArrowRight") handlers.next();
            else if (event.key === " " && handlers.togglePlay) handlers.togglePlay();
            else return;
            event.preventDefault();
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    });
}
